import { cn } from '../../lib/cn';
import type { ChestTier } from '../../lib/chest';

interface Props {
  tier: ChestTier;
  state?: 'closed' | 'open';
  size?: number;
  className?: string;
}

export function Chest({ tier, state = 'closed', size = 56, className }: Props) {
  return (
    <img
      src={`/chests/${tier}-${state}.jpg`}
      alt={`${tier} chest ${state}`}
      width={size}
      height={size}
      className={cn('object-contain select-none pointer-events-none', className)}
      draggable={false}
    />
  );
}
